module.exports = __webpack_public_path__ + "img/left_arrow.04a568fa.svg";